{
  "tabs": {
    "chat": "চ্যাট",
    "reminders": "স্মরণিকা",
    "calendar": "ক্যালেন্ডার",
    "settings": "সেটিংস"
  },
  "common": {
    "cancel": "বাতিল",
    "save": "সংরক্ষণ",
    "confirm": "নিশ্চিত করুন",
    "delete": "মুছে ফেলুন",
    "back": "পেছনে",
    "close": "বন্ধ করুন",
    "edit": "সম্পাদনা",
    "search": "অনুসন্ধান",
    "all": "সব",
    "loading": "লোড হচ্ছে...",
    "error": "কিছু ভুল হয়েছে",
    "notFound": "কিছু পাওয়া যায়নি",
    "tryAgain": "আবার চেষ্টা করুন",
    "retry": "পুনরায় চেষ্টা",
    "undo": "পূর্বাবস্থায় ফিরুন",
    "pullToRefresh": "রিফ্রেশ করতে টানুন",
    "justNow": "এখনই"
  },
  "auth": {
    "welcome": "FishMemory-তে স্বাগতম",
    "tagline": "আপনার WhatsApp স্মরণিকা সহকারী, এখন আপনার পকেটে।",
    "subtitle": "আপনার WhatsApp স্মরণিকা সহকারী, এখন আপনার পকেটে।",
    "phoneLabel": "আপনার WhatsApp নম্বর",
    "phoneHint": "আমরা WhatsApp এর মাধ্যমে যাচাইকরণ কোড পাঠাবো",
    "invalidPhone": "দয়া করে সঠিক ফোন নম্বর দিন",
    "continue": "চালিয়ে যান",
    "enterPhone": "আপনার WhatsApp নম্বর লিখুন",
    "phonePlaceholder": "ফোন নম্বর",
    "sendCode": "কোড পাঠান",
    "verifyTitle": "আপনার নম্বর যাচাই করুন",
    "otpSentTo": "একটি ৬-অঙ্কের কোড {{phone}} এ WhatsApp এর মাধ্যমে পাঠানো হয়েছে",
    "enterFullCode": "সকল ৬ অঙ্ক লিখুন",
    "invalidOtp": "অবৈধ কোড। আবার চেষ্টা করুন।",
    "otpFailed": "কোড পাঠাতে ব্যর্থ। আবার চেষ্টা করুন।",
    "otpResent": "কোড পুনরায় পাঠানো হয়েছে",
    "resendIn": "{{seconds}} সেকেন্ডে পুনরায় পাঠান",
    "resendCode": "কোড পুনরায় পাঠান",
    "enterOtp": "আপনার WhatsApp এ পাঠানো কোড লিখুন",
    "verify": "যাচাই করুন",
    "resend": "কোড পুনরায় পাঠান",
    "wrongNumber": "ভুল নম্বর?",
    "backToPhone": "ফোনে ফিরে যান",
    "editPhone": "ফোন নম্বর সম্পাদনা করুন",
    "error": "ত্রুটি",
    "setupTitle": "চলুন শুরু করি",
    "setupSubtitle": "আপনি পরে সেটিংসে এগুলো পরিবর্তন করতে পারবেন",
    "namePlaceholder": "আপনার নাম",
    "letsGo": "সেটআপ শেষ করুন",
    "skipForNow": "এখন বাদ দিন"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "একটি বার্তা টাইপ করুন...",
    "inputPlaceholder": "একটি বার্তা টাইপ করুন...",
    "typing": "FishMemory টাইপ করছে...",
    "online": "অনলাইনে",
    "connecting": "সংযোগ হচ্ছে...",
    "reconnecting": "পুনরায় সংযোগ হচ্ছে...",
    "offline": "অফলাইন",
    "empty": "একটি কথোপকথন শুরু করুন",
    "emptyHint": "স্মরণিকা তৈরি করুন, আপনার সময়সূচী দেখুন, অথবা সাহায্য চাইুন।",
    "emptyAction": "একটি নমুনা স্মরণিকা পাঠান",
    "actions": "চ্যাট ক্রিয়াকলাপ",
    "keep": "বার্তা রাখুন",
    "clearTitle": "চ্যাট মুছুন",
    "clearConfirm": "এই ডিভাইস থেকে সব বার্তা মুছে ফেলবেন? এটি পূর্বাবস্থায় ফিরানো যাবে না।",
    "clear": "চ্যাট মুছুন",
    "optionSelected": "নির্বাচিত: {{label}}",
    "sendingSelection": "পাঠানো হচ্ছে...",
    "connectionLost": "পুনরায় সংযোগ হচ্ছে..."
  },
  "reminders": {
    "title": "আমার স্মরণিকা",
    "active": "সক্রিয়",
    "today": "আজ",
    "thisWeek": "এই সপ্তাহ",
    "history": "ইতিহাস",
    "items": "আইটেম",
    "emptyTitle": "কোন স্মরণিকা নেই",
    "emptySubtitle": "চ্যাট থেকে একটি তৈরি করুন, এটি এখানে দেখানো হবে।",
    "emptyAction": "চ্যাট খুলুন",
    "filterActive": "সক্রিয়",
    "filterToday": "আজ",
    "filterWeek": "এই সপ্তাহ",
    "filterHistory": "ইতিহাস",
    "emptyState": "কোন স্মরণিকা নেই। চ্যাট শুরু করুন!",
    "swipeDone": "সম্পন্ন",
    "swipeSnooze": "স্নুজ",
    "swipeDelete": "মুছে ফেলুন",
    "search": "স্মরণিকা অনুসন্ধান...",
    "upcoming": "আসন্ন",
    "completed": "সম্পন্ন",
    "overdue": "বিলম্বিত",
    "tomorrow": "আগামীকাল",
    "synced": "সমন্বয়িত {{value}}",
    "swipeHint": "অতিরিক্ত ক্রিয়ার জন্য স্মরণিকা সোয়াইপ করুন",
    "noResults": "আপনার অনুসন্ধানের সাথে কোন স্মরণিকা মেলে না",
    "noResultsHint": "অন্য কীওয়ার্ড চেষ্টা করুন অথবা অনুসন্ধান মুছুন",
    "deleteAllFailed": "সব স্মরণিকা মুছে ফেলতে ব্যর্থ"
  },
  "calendar": {
    "title": "ক্যালেন্ডার",
    "today": "আজ",
    "tomorrow": "আগামীকাল",
    "completed": "সম্পন্ন",
    "noEvents": "কোনো নির্ধারিত ঘটনা নেই",
    "noEventsSubtitle": "স্মরণিকা এবং ক্যালেন্ডার ইভেন্ট দেখতে একটি তারিখ নির্বাচন করুন।",
    "googleEvent": "Google Calendar",
    "legendActive": "সক্রিয়",
    "legendRecurring": "পুনরাবৃত্তি",
    "legendDone": "সম্পন্ন",
    "legendGoogle": "Google",
    "previousMonth": "গত মাস",
    "nextMonth": "পরবর্তী মাস",
    "previousYear": "গত বছর",
    "nextYear": "পরবর্তী বছর",
    "goToToday": "আজকে যান",
    "all": "সব",
    "active": "সক্রিয়",
    "done": "সম্পন্ন",
    "paused": "বিরতি"
  },
  "settings": {
    "title": "সেটিংস",
    "profile": "প্রোফাইল",
    "name": "প্রদর্শনের নাম",
    "enterName": "আপনার নাম লিখুন",
    "language": "ভাষা",
    "uiLanguage": "অ্যাপ ভাষা",
    "uiLanguageHelp": "এই ডিভাইসে অ্যাপ UI, ক্যালেন্ডার লেবেল এবং বিন্যাসের দিক পরিবর্তন করে।",
    "serverLanguage": "চ্যাট ভাষা",
    "serverLanguageHelp": "আপনার অ্যাকাউন্টের জন্য সার্ভারের উত্তর এবং স্মরণিকা বার্তার ভাষা পরিবর্তন করে।",
    "timezone": "টাইমজোন",
    "currentTimezone": "বর্তমান টাইমজোন",
    "timezoneHelp": "সমস্ত স্মরণিকার সময় এই টাইমজোন ব্যবহার করে দেখানো হয়।",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "টাইমজোন সংরক্ষণ",
    "timezoneSaved": "টাইমজোন আপডেট হয়েছে",
    "detect": "সনাক্ত করুন",
    "detectFailed": "টাইমজোন সনাক্ত করতে ব্যর্থ",
    "autoDetect": "GPS থেকে স্বয়ংক্রিয় সনাক্তকরণ",
    "notifications": "নোটিফিকেশন",
    "notificationsHelp": "ফলো-আপ স্মরণিকা স্মরণিকা দেওয়ার পরে পুনরাবৃত্তি সতর্কতা নিয়ন্ত্রণ করে। ডিভাইস-স্তরের নোটিফিকেশন অনুমতি আপনার ফোন সেটিংসে পরিচালিত হয়।",
    "pushEnabled": "পুশ নোটিফিকেশন",
    "autoDoneOnFire": "ফায়ার হলে স্বয়ংক্রিয় সম্পন্ন চিহ্নিতকরণ",
    "autoDoneOnFireDesc": "বন্ধ থাকলে, স্মরণিকা সক্রিয় থাকে যতক্ষণ না আপনি সম্পন্ন হিসেবে চিহ্নিত করেন।",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "সংযুক্ত",
    "googleDisconnected": "সংযুক্ত নয়",
    "googleConnectedHelp": "নতুন স্মরণিকা স্বয়ংক্রিয়ভাবে আপনার ক্যালেন্ডারে সমন্বয় করা যেতে পারে।",
    "googleDisconnectedHelp": "স্মরণিকা এবং ইভেন্ট সামঞ্জস্য রাখতে Google Calendar সংযুক্ত করুন।",
    "googleConnectFailed": "Google Calendar সংযোগ ব্যর্থ",
    "connected": "সংযুক্ত",
    "disconnected": "সংযুক্ত নয়",
    "connect": "সংযুক্ত করুন",
    "disconnect": "সংযোগ বিচ্ছিন্ন করুন",
    "autoSync": "নতুন স্মরণিকা স্বয়ংক্রিয় সমন্বয়",
    "autosync": "নতুন স্মরণিকা স্বয়ংক্রিয় সমন্বয়",
    "subscription": "সাবস্ক্রিপশন",
    "trialUsed": "ট্রায়াল: {{used}}/{{total}} ব্যবহার হয়েছে",
    "trialStatus": "ট্রায়াল উপলব্ধ",
    "activeStatus": "সক্রিয় সাবস্ক্রিপশন",
    "expiredStatus": "সাবস্ক্রিপশন মেয়াদ শেষ",
    "unsubscribedStatus": "সাবস্ক্রাইব করা হয়নি",
    "about": "সম্পর্কে",
    "version": "সংস্করণ",
    "logout": "লগ আউট",
    "logoutTitle": "লগ আউট",
    "logoutConfirm": "আপনি কি নিশ্চিত লগ আউট করতে চান?",
    "noName": "কোন নাম সেট করা হয়নি",
    "serverConnection": "সার্ভার সংযোগ",
    "serverUrl": "সার্ভার URL",
    "serverEdit": "সম্পাদনা",
    "saveReconnect": "সংরক্ষণ ও পুনরায় সংযোগ",
    "resetDefault": "ডিফল্ট রিসেট করুন",
    "invalidServerUrlTitle": "অবৈধ সার্ভার URL",
    "invalidServerUrlMessage": "একটি বৈধ http বা https সার্ভার URL লিখুন, যেমন https://example.com",
    "uiLanguageChangeFailed": "অ্যাপ ভাষা পরিবর্তনে ব্যর্থ। আবার চেষ্টা করুন।",
    "serverLanguageChangeFailed": "চ্যাট ভাষা পরিবর্তনে ব্যর্থ। আবার চেষ্টা করুন।",
    "timezoneChangeFailed": "টাইমজোন পরিবর্তনে ব্যর্থ। আবার চেষ্টা করুন।",
    "autoSyncChangeFailed": "স্বয়ংক্রিয় সমন্বয় আপডেটে ব্যর্থ। আবার চেষ্টা করুন।",
    "nameChangeFailed": "প্রদর্শনের নাম আপডেটে ব্যর্থ। আবার চেষ্টা করুন।",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "স্মরণিকার বিবরণ",
    "editTime": "সময় সম্পাদনা",
    "rename": "নাম পরিবর্তন",
    "snooze": "স্নুজ",
    "snooze15": "১৫ মিনিট স্নুজ",
    "pause": "বিরতি",
    "pauseReminder": "স্মরণিকা বিরতি দিন",
    "resume": "পুনরায় চালু",
    "resumeReminder": "স্মরণিকা পুনরায় চালু করুন",
    "skip": "পরবর্তী বাদ দিন",
    "skipOccurrence": "এই ঘটনা বাদ দিন",
    "syncGoogle": "Google-এ সমন্বয় করুন",
    "delete": "মুছে ফেলুন",
    "deleteTitle": "স্মরণিকা মুছুন",
    "deleteConfirm": "এই স্মরণিকাটি স্থায়ীভাবে মুছে ফেলা হবে।",
    "deleteRecurringTitle": "পুনরাবৃত্ত স্মরণিকা মুছুন",
    "deleteRecurringMessage": "আপনি কি এই ঘটনার পুনরাবৃত্তি বাদ দিতে চান নাকি পুরো সিরিজ মুছে ফেলতে চান?",
    "deleteThisOccurrence": "এই ঘটনা বাদ দিন",
    "deleteEntireSeries": "পুরো সিরিজ মুছুন",
    "done": "সম্পন্ন",
    "markDone": "সম্পন্ন হিসেবে চিহ্নিত করুন",
    "undo": "পুনরুদ্ধার",
    "undoPrompt": "আবার সক্রিয় করতে চান? এখনই পুনরুদ্ধার করুন।",
    "recurring": "পুনরাবৃত্ত",
    "nextRun": "পরবর্তী চালনা",
    "oneTime": "এককালীন",
    "pending": "বিচারাধীন",
    "sent": "পাঠানো হয়েছে",
    "paused": "বিরতি",
    "active": "সক্রিয়",
    "snoozed": "স্নুজ করা হয়েছে",
    "localTime": "আপনার স্থানীয় সময়ে দেখানো হয়েছে",
    "recurrence": "পুনরাবৃত্তি",
    "created": "তৈরি হয়েছে",
    "tags": "ট্যাগ",
    "fireCount": "বার ফায়ার হয়েছে",
    "actions": "ক্রিয়াকলাপ",
    "none": "কোনো নেই",
    "snoozeFailed": "স্মরণিকা স্নুজ করতে ব্যর্থ",
    "pauseFailed": "স্মরণিকা বিরতি দিতে ব্যর্থ",
    "resumeFailed": "স্মরণিকা পুনরায় চালু করতে ব্যর্থ",
    "skipFailed": "স্মরণিকা বাদ দিতে ব্যর্থ",
    "doneFailed": "স্মরণিকা সম্পন্ন হিসেবে চিহ্নিত করতে ব্যর্থ",
    "undoFailed": "স্মরণিকা অবস্থা পুনরুদ্ধারে ব্যর্থ",
    "deleteFailed": "স্মরণিকা মুছে ফেলতে ব্যর্থ",
    "rescheduleTitle": "পুনঃনির্ধারণ করবেন?",
    "rescheduleMsg": "এই স্মরণিকাটি বিলম্বিত। আপনি কি এটি পুনঃনির্ধারণ করতে চান?",
    "reschedule15": "১৫ মিনিটে",
    "reschedule60": "১ ঘন্টায়",
    "keepOverdue": "যেমন আছে রাখুন"
  },
  "onboarding": {
    "slide1Title": "FishMemory-তে স্বাগতম",
    "slide1Sub": "আপনার ব্যক্তিগত স্মরণিকা সহকারী — WhatsApp দ্বারা চালিত এবং আপনার পকেটের জন্য তৈরি।",
    "slide2Title": "প্রাকৃতিকভাবে চ্যাট করুন",
    "slide2Sub": "আপনার ভাবনার মতো স্মরণিকা টাইপ করুন: \"আগামীকাল দুপুর ৩টায় মাকে ফোন করার কথা মনে করিয়ে দাও\" — বাকিটা আমরা দেখব।",
    "slide3Title": "কখনো কিছু মিস করবেন না",
    "slide3Sub": "সময়মতো নোটিফিকেশন পান, ট্যাগ দিয়ে সংগঠিত করুন, এবং গুরুত্বপূর্ণ সবকিছু নিয়ন্ত্রণে রাখুন।",
    "getStarted": "শুরু করুন",
    "next": "পরবর্তী",
    "firstReminderTitle": "আপনার প্রথম স্মরণিকা তৈরি করুন!",
    "firstReminderHint": "এমন কিছু টাইপ করে দেখুন:",
    "firstReminderExample": "আগামীকাল সকাল ৯টায় পানি পান করার কথা মনে করিয়ে দাও",
    "gotIt": "বুঝেছি!",
    "notifRationaleTitle": "সময়ে থাকুন",
    "notifRationaleBody": "FishMemory আপনাকে সময়মতো স্মরণ করাতে নোটিফিকেশন দরকার। আপনি শুধুমাত্র আপনি তৈরি করা স্মরণিকার জন্য সতর্কতা পাবেন।",
    "notifRationaleAllow": "নোটিফিকেশন চালু করুন",
    "notifRationaleLater": "পরে হতে পারে",
    "swipeHint": "দ্রুত ক্রিয়ার জন্য ডানদিকে সোয়াইপ করুন →",
    "calendarDragHint": "বিস্তৃত করতে টানুন ↕"
  }
}
